import { render } from "./app-form-checkbox.vue?vue&type=template&id=ab2afe38"
import script from "./app-form-checkbox.vue?vue&type=script&lang=js"
export * from "./app-form-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/app-form-checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab2afe38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab2afe38', __exports__)) {
    console.log('reload')
    api.reload('ab2afe38', __exports__)
  }
  
  module.hot.accept("./app-form-checkbox.vue?vue&type=template&id=ab2afe38", () => {
    console.log('re-render')
    api.rerender('ab2afe38', render)
  })

}


export default __exports__